import useSWR, { type SWRConfiguration } from 'swr';
import useOwnerOrgId from '@/lib/hooks/useOwnerOrgId';
import { fetcher } from '@/utils/services';

const useExternalIntegrations = (
  orgId: string | null = null,
  swrOptions: SWRConfiguration = {},
) => {
  const ownerOrgId = orgId || useOwnerOrgId();
  const key = ownerOrgId
    ? `external-integrations?owner_org_id=${ownerOrgId}`
    : null;

  return useSWR(key, fetcher, swrOptions);
};

export default useExternalIntegrations;
